module.exports = __webpack_public_path__ + "img/ES0081.ad6a3037.png";